<template>
  <span
    class="pill-kind"
    :class="color"
  >
    {{ kind | lowercase | capitalize }}
  </span>
</template>

<script>
import slugify from 'slugify';

export default {
    name: 'PillKind',
    props: {
        kind: {
            type: String,
            default: '',
        },
    },
    computed: {
        color() {
            if (this.kind) {
                return `pill-kind--${slugify(this.kind.toLowerCase())}`;
            }
            return '';
        },
    },
};
</script>

<style lang="scss" scoped>
.pill-kind{
    border        : solid 1px #999;
    color         : #999;
    text-transform: uppercase;
    font-size     : 0.625rem;
    border-radius : 3px;
    padding       : 0 0.3rem;
    line-height   : 1;

    &--licenciatura{
        border-color: #6342CB;
        color: #6342CB;
    }

    &--tecnico-superior{
        border-color: #04C2CA;
        color: #04C2CA;
    }
}
</style>
